"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPENT_AGAINST_BUDGETS_SUFFIX_COPY = exports.SPENT_AGAINST_BUDGETS_COPY = void 0;
exports.spentAgainstBudgets = spentAgainstBudgets;
/**
 * FP-183 (Paul, 2026-10-12, option b): the Budgets page's spent figure counts only
 * spending in categories that have a budget, and says so.
 *
 * It read "Total spent this month" on both apps while summing the three buckets'
 * actuals: every categorised outflow, budgeted or not, plus the savings bucket's
 * goal contributions and card paydown. "Total" over a subset, and "Left in budget"
 * subtracted spending that no budget covered from a budgeted total. It now pairs
 * like with like: both figures cover the same categories.
 *
 * The rule, agreed by web and mobile:
 * - a category is budgeted when its budget is above $0;
 * - a budgeted category with no spending adds $0;
 * - spending that still needs a category, the savings ledger-only amounts (goal
 *   contributions, card paydown) and unbudgeted categories are out. The month's
 *   "needs a category" line stays under the figure.
 *
 * `actual` can't be negative: the server sums each outflow's magnitude and drops
 * refunds, so no flooring is needed here (checked 2026-10-12, budget_service).
 */
exports.SPENT_AGAINST_BUDGETS_COPY = "Spent against your budgets";
/** The same figure after its amount, in Budget vs. Actual's summary line ("$4,048 …"). */
exports.SPENT_AGAINST_BUDGETS_SUFFIX_COPY = "spent against your budgets";
function money(value) {
    const n = typeof value === "number" ? value : parseFloat(value);
    return Number.isFinite(n) ? n : 0;
}
/** Spending and budget summed over the budgeted categories only (the same set for both). */
function spentAgainstBudgets(rows) {
    let spent = 0;
    let budgeted = 0;
    for (const row of rows) {
        const b = money(row.budgeted);
        if (b <= 0)
            continue;
        budgeted += b;
        spent += money(row.actual);
    }
    return { spent, budgeted };
}
//# sourceMappingURL=budgetTotalsCopy.js.map